import {
  IDeductionActivityRepository,
  IDeductionActivityRepositoryParams,
  IDeductionActivityRepositoryResponse,
  IExportDeductionActivityRepositoryRequest,
} from "@/core/repositories/deduction";
import { DeductionActivity, DeductionActivityProps } from "@/core/entities/deduction";
import { ApolloClient } from "@apollo/client";
import { GET_DEDUCTION_ACTIVITY } from "@/core/graphql/activity";
import { PrivateHttp } from "@/infrastructure/adapters/http";
import { ApiEndpoints } from "@/infrastructure/services/config";
import { ContentType } from "@ir/core/http";

interface IQueryResponse<T> {
  deductionId: number;
  hasMore: boolean;
  total: number;
  page: number;
  limit: number;
  items: T[];
}

interface IDeductionActivityQueryResponse {
  deductionActivities: IQueryResponse<DeductionActivityProps>;
}

export class DeductionActivityRepository implements IDeductionActivityRepository {
  constructor(private readonly client: ApolloClient) {}

  async getActivities(params: IDeductionActivityRepositoryParams): Promise<IDeductionActivityRepositoryResponse> {
    const { data } = await this.client.query<IDeductionActivityQueryResponse>({
      query: GET_DEDUCTION_ACTIVITY,
      variables: { params },
      fetchPolicy: "network-only",
    });

    if (!data?.deductionActivities) {
      throw new Error("Failed to get deduction activities");
    }

    return {
      deductionId: data.deductionActivities.deductionId,
      hasMore: data.deductionActivities.hasMore,
      deductionActivities: data.deductionActivities.items.map(deductionActivity => DeductionActivity.from(deductionActivity)),
      total: data.deductionActivities.total,
      page: data.deductionActivities.page,
      limit: data.deductionActivities.limit,
    };
  }

  async exportActivities(data: IExportDeductionActivityRepositoryRequest): Promise<{ signedUrl: string; success: boolean }> {
    const response = await new PrivateHttp({
      headers: {
        "Content-Type": ContentType.JSON,
      },
    }).post<{ signedUrl: string; success: boolean }>(ApiEndpoints.DEDUCTION_ACTIVITIES_EXPORT, data);

    return response;
  }
}
